<div id="managefeaturedplan" class="p-0 col-lg-12" *ngIf="updatePlanData">
  <div class="p-0 pb-8 status-reminder align-items-baseline">
    <div class="col-md-6 col-lg-6 p-0">
      <span class="p-1 gb-body1 heavy"
        >{{ updatePlanData.featuredCopy?.copy }}
      </span>
    </div>
    <div *ngIf="updatePlanData.offers"
      class="d-flex align-items-center justify-content-between ml-auto">
      <span
        class="p-0 firstlet-cap gb-body3 medium-screen-custom-order-right mr-1"
        >{{ updatePlanData.offers[0].prices[0].discountCopy }}
      </span>
      <div
        class="cit2-badge-discount mt-1"
        *ngIf="updatePlanData.offers[0].prices[0].discountPercentage"
      >
        <span aria-hidden="true" class="icon-ui-offer-tag"></span>
        <div class="gb-body2 heavy">
          <p class="mb-0">
            {{ updatePlanData.offers[0].prices[0].discountPercentage }}
          </p>
        </div>
      </div>
      <!-- <span class="firstlet-cap gb-body3">
        <div *ngIf="updatePlanData.offers[0].prices[0].discountPercentage">
          <button
            class="col-12 firstlet-cap gb-body3 offer-btn text-nowrap"
            aria-label="Offer"
          >
            {{ updatePlanData.offers[0].prices[0].discountPercentage }} off
          </button>
        </div>
      </span> -->
    </div>
  </div>
  
  <carousel
    [itemsPerSlide]="itemsPerSlide"
    [singleSlideOffset]="true"
    [interval]="0"
    [noWrap]="false"
    [showIndicators]="false"
    (slideRangeChange)="log($event)"
    (activeSlideChange)="handleNavButtons($event)"
    
  >
    <slide
      *ngFor="let value of nth_time; let i = index"
      class="p-0 card-cls mt-3"
      [ngClass]="getClass(nth_time.length)"
    >
      <div *ngIf="value"
        class="d-flex p-8 empdet-cls p-2"
        [ngClass]="selectedindex === i ? 'selected' : 'unselected'"
      >
        <div *ngIf="updatePlanData.byoCopy"
          class="selectedlabel"
          [style.visibility]="selectedindex === i ? 'visible' : 'hidden'"
        >
          <span class="selectedicon float-left" routerLink="">
            <h6 class="selectedtext">
              {{ updatePlanData.byoCopy.selected.label }}
            </h6>
            <span class="btn-icn icon-dummy_profile btn-acc btn-log">
              <span aria-hidden="true" class="icon-ui-check icon-check"></span
            ></span>
          </span>
        </div>
        <div class="empdet-rgt">
          <div class="col-12 p-0">
            <div
              [style.visibility]="
                value?.price?.status === 'Active' ? 'visible' : 'hidden'
              "
              class="p-0 emp-det"
            >
              <span class="firstlet-cap gb-body2 pb-6">{{
                getCopy('eyebrow.my.current.plan.copy')
              }}</span>
            </div>
            <div>
              <span class="gb-headline2 heavy plan-name-title ">
                <a (click)="openServiceMainModal(i)" role="button">{{
                  value?.name
                }}</a>
              </span>
            </div>
            <div class="mt-2 pb-5">
              <span class="gb-body2 headsublabel">{{
                value?.description
              }}</span>
            </div>
            <div class="pb-3 emp-det mt-3">
              <span class="firstlet-cap gb-headline1 d-inline-block">
                {{ value?.price?.customerFinalPrice | currency }}
              </span>
              <span class="firstlet-cap emp-name gb-body2 d-inline-block"
              *ngIf="
              value?.price?.customerFinalPrice 
              !== value?.price?.retailPrice">
              {{ value?.price?.retailPrice | currency }}
              </span>
              <span class="gb-body3 d-inline-block">
                {{ value?.price?.billingFrequencyCopy }}</span
              >
            </div>
          </div>
          <div
            class="p-0 mb-6"
            [style.visibility]="selectedindex !== i ? 'visible' : 'hidden'"
          >
            <button
              class="col-12 p-1 firstlet-cap gb-primary-button"
              aria-label="Switch plan "
              (click)="
                fireTrackingEvent('button', value?.name, getCopy('switch.plan')); onselected(i)"
            >
              {{ getCopy('switch.plan') }}
            </button>
          </div>
          <div class="p-0">
            <div
              class="col-md-12 p-0 status-cls mb-5"
              *ngFor="
                let feature of value?.featureGroup | keyvalue: reverseKeyOrder
              "
            >
              <div class="col-12 p-0 border_none mb-2">
                <span *ngIf="feature.key !== 'ONSTAR'" class="pb-2 pl-0 pr-0 gb-body1 heavy mb-6">{{
                  feature.key
                }} </span>
                <span *ngIf="feature.key === 'ONSTAR'" class="pb-2 pl-0 pr-0 gb-body1 heavy mb-6">
                  OnStar
                </span>
              </div>
              <div class="col-12 p-0 FAQ">
                <div
                  class="col-12 pb-2 pl-0 pr-0 mb-2 header-css border_none"
                  *ngFor="
                    let featureValue of filterServices($any(feature).value)
                  "
                >
                  <div class="fixed">
                    <span
                      class="gb-body2 pb-2"
                      [ngClass]="{
                        strikeword: !featureValue.isAvailable
                        }"
                      (click)="openServiceModal(i, featureValue)"
                    >
                      <a (click)="
                      fireTrackingEvent('link', 'current plan:' + value?.name + ':' + featureValue.name, 'description');
                    ">
                        {{
                          replaceBrand(
                            featureValue.name,
                            (activeVehicle$ | async)?.make
                          )
                        }}
                      </a></span
                    >
                    <div class="float-right d-flex"
                      [ngClass]="{displaynone: !featureValue.isAvailable}"
                    >
                      <button
                        class="btn-icn icon-dummy_profile btn-acc btn-log"
                        (click)="
                          this.fireTrackingEvent('link', 'current plan:' + value?.name + ':' + featureValue.name, 'description');
                          openServiceModal(i, featureValue)
                        "
                      >
                        <span aria-hidden="true" class="icon-ui-arrowright">
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12 p-0 status-cls">
              <div
                class="col-12 p-0 mb-6"
                (click)="
                  showservices();
                  fireTrackingEvent('link', value?.name, 'show all services');
                "
              >
                <span
                  class="pl-0 pr-0 firstlet-cap borderbottomdisclosure gb-body1 m-0 cursorpointer"
                  *ngIf="hideServices"
                  [translate]="'manage_plans_show_all_services'"
                >
                  + {{ getCopy('show.more.services.copy') }}</span
                >
              </div>

              <div
                class="col-12 p-0 mb-6"
                (click)="
                  lessservices();
                  fireTrackingEvent('link', value?.name, 'less services');
                "
              >
                <span
                  class="pl-0 pr-0 firstlet-cap borderbottomdisclosure gb-body1 m-0 cursorpointer"
                  *ngIf="lessbutton"
                  >- {{ getCopy('plan.less') }}</span
                >
              </div>
            </div>
          </div>
          <div class="col-md-12 p-0 status-cls" *ngIf="value?.disclosure">
            <button
              class="pl-0 pr-0 pb-0 mb-0 firstlet-cap borderbottomdisclosure cursorpointer gb-body3 viewdisclosurelink"
              gb-body3
              (click)="
                openDisclosureModal(value);
                fireTrackingEvent('link', value?.name, 'price disclosures');
              "
              [translate]="'view_disclosures'"
            ></button>
          </div>
        </div>
      </div>
    </slide>
  </carousel>
</div>